import { render, staticRenderFns } from "./AddCardsDialog.vue?vue&type=template&id=12279b05"
import script from "./AddCardsDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddCardsDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/cards/locales/i18n-card-dialogs.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Frobinkopitz%2FDocuments%2Fwork%2Frepos%2Fsmartregion%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2Fcards%2Fchildren%2FAddCardsDialog.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports